import { Route } from "vue-router";
import { OAuthMiddleware, LoggerService as lgg } from "vue-components-library";

import Store from "@/App/store";
import AuthorizationService from "@/Login/services/Authorization.Service";

const WHITELIST = new Set(["/", "/protocol"]);
const LOG_TAG = "[LOGGED IN MIDDLEWARE]";

export async function isLoggedIn(to: Route, from: Route, next: Function) {
  const isAuthenticated = Store.getters["Login/authToken"];
  const isTeamSelected = Store.getters["TeamSelection/selectedTeam"];
  const isTruckSelected = Store.getters["TruckSelection/selectedTruck"];
  const isCaseActive = Store.getters["Case/isCaseActive"];

  try {
    await Store.dispatch("Login/setupWorkspaceApp");
  } catch (error) {
    lgg.error(`${LOG_TAG} Failed to setup Workspace App`, { error });
  }

  if (!isAuthenticated && !WHITELIST.has(to.path)) {
    next("/");
    return;
  } else if (await mustSignin()) {
    OAuthMiddleware.setTokenHandlers({
      verify(idToken: string) {
        return AuthorizationService.loginByToken(idToken);
      },
      success(loginResponse) {
        Store.dispatch("Login/setupUser", loginResponse).then(() => next({ name: "team-selection" }));
      },
      error(err: Error) {
        Store.dispatch("Login/setGeneralError", err);
      },
    });

    const workspaceApp = Store.getters["Login/workspaceApp"];

    return OAuthMiddleware.handle(next, workspaceApp);
  } else if (isAuthenticated && !isTeamSelected && to.path !== "/team-selection") {
    next("/team-selection");
    return;
  } else if (isAuthenticated && !isTruckSelected && to.path !== "/truck-selection" && to.path !== "/team-selection") {
    next("/truck-selection");
    return;
  } else if (isAuthenticated && isCaseActive && to.path !== "/case") {
    next("/case");
    return;
  } else if (isAuthenticated && !isCaseActive && to.path === "/case") {
    next("/start");
    return;
  } else if (isAuthenticated && to.path === "/") {
    next("/start");
    return;
  } else {
    /**
     * Should continue to regular next step (expected route).
     */
    next();
  }
}

async function mustSignin(): Promise<Boolean> {
  const localTokenMissing = !Store.getters["Login/authToken"];
  const localTokenExpired = !(await Store.dispatch("Login/isTokenValid"));

  return localTokenMissing || localTokenExpired;
}
